/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-20.
 * Hardcoded row for fee
 */
import React from 'react';
import { TextField } from 'material-ui';

const FeeRow = ({ feeAmount, title, applicable, numberOfItemsEditable, numberOfItems, onChange, feeTotalAmount }) => (
    <div className="display-flex-center">
        <div className="col-md-3 col-xs-12 display-flex-center">{title}</div>
        <div className="col-md-3 col-xs-12 display-flex-center">{applicable}</div>
        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">
            {feeAmount.formatMoney()}
        </div>
        <div className="col-md-1 col-xs-12 display-flex-center display-flex-just-end">
            {
                numberOfItemsEditable ?
                    <TextField
                        id="numberOfItemsOnFee"
                        type="number"
                        inputStyle={{ textAlign: 'right' }}
                        hintStyle={{ textAlign: 'right' }}
                        min="1"
                        fullWidth
                        value={numberOfItems}
                        onChange={(event, newValue) => {
                            onChange(newValue);
                        }}
                    /> :
                    numberOfItems
            }
        </div>
        <div className="col-md-2 col-xs-12  display-flex-center display-flex-just-end">
            {feeTotalAmount.formatMoney()}
        </div>
    </div>
);

export default FeeRow;



// WEBPACK FOOTER //
// ./forms/customPrefactura/feeRow.js